import request from '@/utils/request'

export function getWorkbenchInit() {
  return request({
    url: '/biz/customer-service/workbench-init',
    method: 'get'
  })
}

/** 客服待接入提醒：广播「立即处理」，其他坐席关闭弹窗 */
export function csAlertDismiss(pendingCount) {
  return request({
    url: '/biz/customer-service/alert-dismiss',
    method: 'post',
    params: { pendingCount },
    headers: { repeatSubmit: false }
  })
}

/** 查询最新关闭信号（弹窗打开期间轮询） */
export function csAlertDismissLatest() {
  return request({
    url: '/biz/customer-service/alert-dismiss',
    method: 'get',
    headers: { repeatSubmit: false }
  })
}

export function getTransferAgents() {
  return request({
    url: '/biz/customer-service/transfer-agents',
    method: 'get'
  })
}

export function csTransfer(data) {
  return request({
    url: '/biz/customer-service/transfer',
    method: 'post',
    data
  })
}

export function csHeartbeat() {
  return request({
    url: '/biz/customer-service/heartbeat',
    method: 'post',
    headers: { repeatSubmit: false }
  })
}

export function csOffline() {
  return request({
    url: '/biz/customer-service/offline',
    method: 'post',
    headers: { repeatSubmit: false }
  })
}

export function csClockOut(customerGoEasyIds) {
  return request({
    url: '/biz/customer-service/clock-out',
    method: 'post',
    data: {
      customerGoEasyIds: customerGoEasyIds || []
    },
    headers: { repeatSubmit: false }
  })
}

export function csSyncServingAgent(customerGoEasyId) {
  return request({
    url: '/biz/customer-service/sync-serving-agent',
    method: 'post',
    params: { customerGoEasyId },
    headers: { repeatSubmit: false }
  })
}

export function csReportServingAgent(customerGoEasyId, servingCsAgentId) {
  return request({
    url: '/biz/customer-service/report-serving-agent',
    method: 'post',
    params: { customerGoEasyId, servingCsAgentId },
    headers: { repeatSubmit: false }
  })
}

export function csAdminCustomerAssignments() {
  return request({
    url: '/biz/customer-service/admin/customer-assignments',
    method: 'get'
  })
}

export function csCustomerProfile(userId) {
  return request({
    url: '/biz/user/detail',
    method: 'get',
    params: { id: userId }
  })
}

export function csNotifyCustomerMessage(payload) {
  const data = typeof payload === 'string'
    ? { customerGoEasyId: payload }
    : (payload || {})
  return request({
    url: '/biz/customer-service/notify-customer-message',
    method: 'post',
    data: {
      customerGoEasyId: data.customerGoEasyId,
      messageId: data.messageId,
      messageType: data.messageType,
      preview: data.preview
    },
    headers: { repeatSubmit: false }
  })
}

export function csCalculate(userId, data) {
  return request({
    url: '/biz/customer-service/order/calculate',
    method: 'post',
    params: { userId },
    data
  })
}

export function csSubmitOrder(data) {
  return request({
    url: '/biz/customer-service/order/submit',
    method: 'post',
    data
  })
}

export function csOrderPage(query) {
  return request({
    url: '/biz/customer-service/order/page',
    method: 'get',
    params: query
  })
}

export function csOrderSummary(query) {
  return request({
    url: '/biz/customer-service/order/summary',
    method: 'get',
    params: query
  })
}

export function csAgentList() {
  return request({
    url: '/biz/customer-service/order/agents',
    method: 'get'
  })
}

export function csCountries() {
  return request({
    url: '/biz/customer-service/order/countries',
    method: 'get'
  })
}

export function giftRates(query) {
  return request({
    url: '/biz/giftcard/gift-rates',
    method: 'get',
    params: query
  })
}

export function getCsReadReceipt(customerGoEasyId) {
  return request({ url: '/biz/customer-service/read-receipt', method: 'get', params: { customerGoEasyId } })
}
export function reportCsReadReceipt(customerGoEasyId, throughTimestamp) {
  return request({ url: '/biz/customer-service/read-receipt', method: 'post', params: { customerGoEasyId, throughTimestamp } })
}
